module.exports = __webpack_public_path__ + "static/media/Directory_JNKVV.0be10257.pdf";